import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { Step4Response } from "../../api/types/step4"

type initialState = {
    response: Step4Response | null
}

const step4Slice = createSlice({
    name: "step4",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.step4.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default step4Slice.reducer
